// extracted by mini-css-extract-plugin
export default {"web":"WebDevelopment_web__gzR8s"};